module.exports = __webpack_public_path__ + "img/KISH.2ffb9202.png";